const NotFound = () => {
  return (
    <div className="flex flex-col justify-center min-h-screen">
      <h1 className="text-4xl font-bold text-center">Sivua ei löytynyt</h1>
    </div>
  )
}

export default NotFound
